module.exports = {
	env: 'prod'
}
